import React from 'react';

/**
 * Compact, sectioned card used by order-management detail views.
 * Mirrors the DeliveryOrder "Order Details" card style.
 */
const ACCENTS = {
  blue: { light: 'bg-blue-50 border-blue-100', dark: 'bg-blue-900/20 border-blue-800' },
  green: { light: 'bg-green-50 border-green-100', dark: 'bg-emerald-900/20 border-emerald-800' },
  amber: { light: 'bg-amber-50 border-amber-100', dark: 'bg-amber-900/20 border-amber-800' },
  purple: { light: 'bg-purple-50 border-purple-100', dark: 'bg-purple-900/20 border-purple-800' },
  gray: { light: 'bg-gray-50 border-gray-200', dark: 'bg-gray-800 border-gray-700' },
};

const DetailSection = ({ title, icon: Icon, accent = 'gray', isDarkMode = false, className = '', children }) => {
  const tone = ACCENTS[accent] || ACCENTS.gray;

  return (
    <section className={`rounded-lg border shadow-sm p-4 ${isDarkMode ? tone.dark : tone.light} ${className}`}>
      {title && (
        <h4 className={`flex items-center text-sm font-semibold mb-3 ${isDarkMode ? 'text-gray-100' : 'text-gray-800'}`}>
          {Icon && <Icon className={`w-4 h-4 mr-2 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`} />}
          {title}
        </h4>
      )}
      {children}
    </section>
  );
};

export default DetailSection;
